import { Backdrop, Box, CircularProgress, FormControlLabel, InputAdornment, Radio, RadioGroup, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { AxiosError } from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as constants from "../../../constants";
import ContainedButton from "../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../shared/Button/customOutlinedButton";
import CustomDatePicker from "../../../shared/CustomDate";
import CustomTextField from "../../../shared/CustomTextFeild";
import { RootState } from "../../../store/store";
import basestyle from "../../CSS/Base.module.css";
import CancelPopUp from "../../PopUp/PopUp";
import {
    getBudgetDocumentDetailsByYearAndLocationId,
    getDisableFRFields,
    getFRPdfByYearAndLocation,
    getFinancialReportDetailsByTypeYear,
    getFinancialReportDetailsByYearandLocationId,
    saveFinanacalReportActualDetails
} from "../services/Financials/budget.service";
import { FinancialReportActualVO } from "../services/Financials/financials";
import {
    SectionTitle,
    StyledInputLabel,
    StyledOneChildContainer,
    StyledParentContainer,
    StyledTwoChildContainer,
    SubSectionTitle
} from "../StyledComponents/Container";
import { formatCurrencywithoutDoller } from "../Utils/formatUtils";
import { notifyUser } from "../Utils/notifyUser";

const ActualsReportView: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const participantDetail = useSelector((state: RootState) => state.participantDetails);
    const [openPopUp, setOpenPopUp] = useState(false);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const userDetails = useSelector((state: RootState) => state.auth);
    const rowData = location.state?.rowData ?? {};
    const { t } = useTranslation();
    const translate = t as (key: string) => string;
    const [documentShowFlag, setDocumentShowFlag] = useState<boolean>(false);
    const [sectionVOList, setSectionVOList] = useState<any[]>([]);
    const [financialReportActualVO, setFinancialReportActualVO] = useState<any[]>([]);
    const forecastYear = rowData?.forecastYear ?? "";
    const [showMessage, setShowMessage] = useState<boolean>(false);
    const [lockFields, setLockFields] = useState<boolean>(false);
    const [roleFlag, setRoleFlag] = useState<boolean>(false);
    const [participantId, setParticipantId] = useState<number>(0);
    const [participantType, setParticipantType] = useState("");

    const handleBack = () => {
        navigate("/actualsListing");
    };
    function createActualObject(locationId: number, year: string, fieldId: number, value: any): FinancialReportActualVO {
        return {
            id: 0,
            locationId,
            year,
            fieldId,
            clientId: userDetails.clientId,
            value,
            isActive: constants.IS_ACTIVE_YES,
        };
    }

    async function handleSave() {
        setLoadingFlag(true);

        try {
            const actualList = [];
            const userEmail = userDetails.emailId;
            if (financialReportActualVO && financialReportActualVO.length > 0) {
                for (const section of sectionVOList) {
                    for (const sectiondetails of section.financialReportMetadataSectionDetails ?? []) {
                        if (Array.isArray(sectiondetails.childDetails) && sectiondetails.childDetails.length > 0) {
                            for (const child of sectiondetails.childDetails) {
                                const actual = financialReportActualVO.find(x => x.fieldId === child.id);
                                if (child.type === "date" && child.value) {
                                    const newDate = `${child.value.date.day}/${child.value.date.month}/${child.value.date.year}`;
                                    if (actual && actual.value !== newDate && child.value.formatted) {
                                        actualList.push({
                                            ...actual,
                                            value: child.value.formatted,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                } else {
                                    if (actual && actual.value !== child.value) {
                                        actualList.push({
                                            ...actual,
                                            value: child.value,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                }
                            }
                        } else {
                            if (sectiondetails.type) {
                                const actual = financialReportActualVO.find(x => x.fieldId === sectiondetails.id);

                                if (sectiondetails.type === "date" && sectiondetails.value) {
                                    const newDate = `${sectiondetails.value.date.day}/${sectiondetails.value.date.month}/${sectiondetails.value.year}`;
                                    if (actual && actual.value !== newDate && sectiondetails.value.formatted) {
                                        actualList.push({
                                            ...actual,
                                            value: sectiondetails.value.formatted,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                } else {
                                    if (actual && actual.value !== sectiondetails.value) {
                                        actualList.push({
                                            ...actual,
                                            value: sectiondetails.value,
                                            lastUpdatedBy: userEmail,
                                            lastUpdatedTime: new Date(),
                                            id: actual.id
                                        });
                                    }
                                }
                            }

                        }
                    }
                }
            } else {

                for (const section of sectionVOList) {
                    for (const sectiondetails of section.financialReportMetadataSectionDetails ?? []) {
                        if (sectiondetails.type && !sectiondetails.childDetails) {
                            if (sectiondetails.type === "date" && sectiondetails.value) {
                                actualList.push(createActualObject(participantId, section.year, sectiondetails.id, sectiondetails.value.formatted));
                            } else {
                                actualList.push(createActualObject(participantId, section.year, sectiondetails.id, sectiondetails.value));
                            }
                        } else if (Array.isArray(sectiondetails.childDetails)) {
                            for (const child of sectiondetails.childDetails) {
                                if (child.type === "date" && child.value) {
                                    actualList.push(createActualObject(participantId, section.year, child.id, child.value.formatted));
                                } else {
                                    actualList.push(createActualObject(participantId, section.year, child.id, child.value));
                                }
                            }
                        }
                    }
                }
            }

            // Save final list 
            if (actualList?.length > 0) {

                const responseList = await saveFinanacalReportActualDetails(actualList);
                if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                    notifyUser(responseList?.data?.message, 'success', translate('actualsReportDetails'));
                    navigate("/actualsListing");
                } else {
                    notifyUser(responseList?.data?.message, 'error', translate('actualsReportDetails'));
                }
            } else {
                notifyUser(constants.ERROR_VALIDATION_MESSAGE_NO_VALUE_HAVE_BEEN_MODIFIED, 'error', translate('actualsReportDetails'));
            }

        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        } finally {
            setLoadingFlag(false);
        }
    }

    async function handlePrint() {
        try {
            const responseList = await getFRPdfByYearAndLocation(forecastYear, participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS && responseList?.data?.data?.contents) {
                const byteArray = new Uint8Array(
                    atob(responseList?.data?.data?.contents)
                        .split("")
                        .map(char => char.charCodeAt(0))
                );

                const file = new Blob([byteArray], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            } else {
                notifyUser(responseList?.data?.message, 'error', translate('actualsReportDetails'));
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    const handleCancel = () => {
        setOpenPopUp(true);
    };

    const handlePopUpClose = () => {
        setOpenPopUp(false);
    };

    function handleConfirm() {
        navigate("/actualsListing");
    }
    const unformatCurrencyInput = (value: any) => {
        return value.replace(/,/g, "");
    };
    const handleFieldChange = (
        type: string,
        itemIndex: number,
        fieldName: string,
        value: string | number | Date
    ) => {
        const updatedSection = [...sectionVOList];
        if (type === "a") {
            updatedSection[itemIndex].financialReportMetadataSectionDetails.forEach((field: any) => {
                if (field.shortName === fieldName) {
                    field.value = value;
                }
            });
        } else {
            updatedSection[itemIndex].financialReportMetadataSectionDetails.forEach((field: any) => {
                if (Array.isArray(field.childDetails)) {
                    field.childDetails.forEach((child: any) => {
                        if (child.shortName === fieldName) {
                            child.value = value;
                        }
                    });
                }
            });
        }
        setSectionVOList(updatedSection);
    };

    useEffect(() => {
        if (userDetails?.defaultParticipantId) {
            setParticipantId(userDetails.defaultParticipantId);
            const participant = (participantDetail.participantsArray as { participantId: string; participantType: string }[]).find((item) => item.participantId === userDetails.defaultParticipantId);
            setParticipantType(participant?.participantType ?? "")

        }
    }, [userDetails?.defaultParticipantId]);

    useEffect(() => {
        if (forecastYear) {
            getDisableFR();
        }
    }, [forecastYear]);

    useEffect(() => {
        if (forecastYear && participantId) {
            getBudgetDocumentDetails();
            getFinancialReport();
        }

    }, [forecastYear, participantId]);
    useEffect(() => {
        if (forecastYear && participantType) {
            getFinancialReportDetails();
        }

    }, [forecastYear, participantType]);



    useEffect(() => {
        if (sectionVOList.length > 0) {
            getFinancialReport();
        }

    }, [sectionVOList.length > 0]);



    async function getFinancialReportDetails() {
        try {
            const responseList = await getFinancialReportDetailsByTypeYear(forecastYear, participantType, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                if (responseList?.data?.data?.sectionVOList) {
                    setSectionVOList(responseList?.data?.data?.sectionVOList);
                    setShowMessage(false);
                } else {
                    setShowMessage(true);
                }
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    async function getBudgetDocumentDetails() {
        try {
            const responseList = await getBudgetDocumentDetailsByYearAndLocationId(forecastYear, participantId, "financial_reports", userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS && responseList?.data?.data?.documentsVOS) {
                setDocumentShowFlag(true);
            } else {
                setDocumentShowFlag(false);

            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    async function getDisableFR() {
        try {
            const responseList = await getDisableFRFields(forecastYear, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                setLockFields(responseList?.data?.data?.lock);
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    async function getFinancialReport() {
        try {
            const responseList = await getFinancialReportDetailsByYearandLocationId(forecastYear, participantId, userDetails.clientId);
            if (responseList?.status === constants.STATUS_CODES.SUCCESS) {
                if (responseList?.data?.data?.financialReportActualVOS != null && responseList?.data?.data?.financialReportActualVOS.length > 0) {
                    setFinancialReportActualVO(responseList?.data?.data?.financialReportActualVOS)
                    const updatedSectionVOList = JSON.parse(JSON.stringify(sectionVOList));
                    for (let section of updatedSectionVOList) {
                        for (let sectiondetails of section.financialReportMetadataSectionDetails) {
                            if (sectiondetails.childDetails != null && sectiondetails.childDetails.length > 0) {
                                for (let child of sectiondetails.childDetails) {
                                    if (child.type != null) {
                                        const obj = responseList.data.data.financialReportActualVOS.find((x: { fieldId: any }) => x.fieldId == child.id);
                                        child.value = obj?.value ?? "";
                                    }
                                }
                            } else {
                                if (sectiondetails.type != null) {
                                    const obj = responseList.data.data.financialReportActualVOS.find((x: { fieldId: any }) => x.fieldId == sectiondetails.id);
                                    let fieldvalue: any = obj != null ? obj.value : null;

                                    if (sectiondetails.type === "date" && fieldvalue != null) {
                                        let dDate = new Date(Date.parse(fieldvalue));
                                        fieldvalue = {
                                            date: {
                                                year: dDate.getFullYear(),
                                                month: dDate.getMonth() + 1,
                                                day: dDate.getUTCDate()
                                            }
                                        };
                                    } else if (sectiondetails.type === "date" && fieldvalue == null) {
                                        fieldvalue = {};
                                    }

                                    sectiondetails.value = fieldvalue;
                                }
                            }
                        }
                    }
                    setSectionVOList(updatedSectionVOList);
                }
            }
        } catch (error) {
            if (error instanceof AxiosError) {
                console.error(translate('axiosError'), error.response?.data ?? error.message);
            } else {
                console.error(translate('unexpectedError'), error);
            }
        }
    }

    return (
        <StyledParentContainer>
            <StyledOneChildContainer>
                <StyledTwoChildContainer sx={{ border: "none" }}>
                    <SectionTitle>
                        {translate('financialReportFiscalYearEnding')} {forecastYear}
                    </SectionTitle>
                    <Box sx={{ width: "100%", px: 1.5 }}>
                        {!showMessage ? (
                            <>
                                {sectionVOList?.map((item, i) => (
                                    <Box key={i}>
                                        {item.name && (
                                            <Box sx={{ backgroundColor: "#ffc107", pl: 1, mt: 0.5, mb: 1 }}>
                                                <SubSectionTitle sx={{ fontSize: "20px" }}>{item.name}</SubSectionTitle>
                                            </Box>
                                        )}

                                        <Grid container spacing={0.5} direction={'column'}>
                                            {item?.financialReportMetadataSectionDetails?.map((list: any, idx: React.Key) => (
                                                <Grid container   >
                                                    <Grid size={{ xs: 12, sm: 8, lg: 10 }} >
                                                        {list.label && <StyledInputLabel
                                                            style={{
                                                                wordWrap: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                display: 'block',
                                                                whiteSpace: 'normal',
                                                                fontSize: "18px"
                                                            }}
                                                        >
                                                            {list.label}
                                                        </StyledInputLabel>}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 4, lg: 2 }}>
                                                        {list.type === 'text' && (
                                                            <CustomTextField
                                                                title={list.value}
                                                                id={list.shortName}
                                                                name={list.shortName}
                                                                value={list.value}
                                                                onChange={(e) =>
                                                                    handleFieldChange("a", i, list.shortName, e.target.value)
                                                                }
                                                                readOnly={lockFields || roleFlag}
                                                            />
                                                        )}
                                                        {list.type === 'number' && (
                                                            <CustomTextField
                                                                title={list.value}
                                                                id={list.shortName}
                                                                name={list.shortName}
                                                                value={list.value}
                                                                onChange={(e) =>
                                                                    handleFieldChange("a", i, list.shortName, e.target.value)
                                                                }
                                                                readOnly={lockFields || roleFlag}
                                                            />
                                                        )}
                                                        {list.type === "currency" && (
                                                            <NumericFormat
                                                                customInput={CustomTextField}
                                                                id={list.shortName}
                                                                name={list.shortName}
                                                                value={list.value ?? ""}
                                                                thousandSeparator
                                                                decimalScale={2}
                                                                fixedDecimalScale={false}
                                                                allowNegative={true}
                                                                placeholder="0.00"
                                                                onValueChange={(values) => {
                                                                    handleFieldChange("a", i, list.shortName, unformatCurrencyInput(values.value));
                                                                }}
                                                                isAllowed={(values) => {
                                                                    const { floatValue } = values;
                                                                    return (
                                                                        floatValue === undefined ||
                                                                        floatValue <= constants.MAX_AMOUNT_ALLOWED
                                                                    );
                                                                }}
                                                                inputProps={{
                                                                    style: {
                                                                        textAlign: "right",
                                                                        paddingLeft: 0,
                                                                        marginRight: 0.1
                                                                    },
                                                                    onPaste: (e: any) => e.preventDefault()
                                                                }}
                                                                InputProps={{
                                                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                                    style: { textAlign: 'right' }
                                                                }}
                                                                readOnly={lockFields || roleFlag}
                                                            />
                                                        )}
                                                        {list.type === "radio" && (
                                                            <RadioGroup
                                                                value={list.value}
                                                                onChange={(e) =>
                                                                    handleFieldChange("a", i, list.shortName, e.target.value)
                                                                }
                                                                row
                                                                sx={{ marginBottom: -6 }}
                                                            >
                                                                <FormControlLabel
                                                                    value="1"
                                                                    control={<Radio sx={{ marginTop: -1 }} />}
                                                                    label="Yes"
                                                                    labelPlacement="end"
                                                                    sx={{
                                                                        '& .MuiFormControlLabel-label': {
                                                                            marginTop: '-8px',
                                                                        }
                                                                    }}
                                                                    disabled={lockFields || roleFlag}
                                                                />
                                                                <FormControlLabel
                                                                    value="0"
                                                                    control={<Radio sx={{ marginTop: -1 }} />}
                                                                    label="No"
                                                                    labelPlacement="end"
                                                                    sx={{
                                                                        '& .MuiFormControlLabel-label': {
                                                                            marginTop: '-8px',
                                                                        }
                                                                    }}
                                                                    disabled={lockFields || roleFlag}
                                                                />

                                                            </RadioGroup>
                                                        )}
                                                        {list.type === 'date' && (
                                                            <CustomTextField
                                                                title={list.value}
                                                                id={list.shortName}
                                                                name={list.shortName}
                                                                value={list.value}
                                                                onChange={(e) =>
                                                                    handleFieldChange("a", i, list.shortName, e.target.value)
                                                                }
                                                                readOnly={lockFields || roleFlag}
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 4, lg: 8 }}>
                                                        {list.type === 'textarea' && (
                                                            <CustomTextField
                                                                multiline
                                                                rows={3}
                                                                title={list.value}
                                                                id={list.shortName}
                                                                name={list.shortName}
                                                                value={list.value} onChange={(e) =>
                                                                    handleFieldChange("a", i, list.shortName, e.target.value)
                                                                }
                                                                inputProps={{
                                                                    maxLength: 450
                                                                }}
                                                                readOnly={lockFields || roleFlag}
                                                            />
                                                        )}
                                                    </Grid>
                                                    <Grid size={12}  >
                                                        {list.childDetails && list.childDetails.length > 0 && (
                                                            <TableContainer>
                                                                <TableHead>
                                                                    <TableRow>
                                                                        {(() => {
                                                                            const validLabels = list.childDetails.filter((clist: any) => clist.label);
                                                                            const columnCount = validLabels.length || 1;
                                                                            const widthPercent = columnCount > 3 ? (97 / columnCount) : (columnCount === 2 ? (36 / columnCount) : columnCount === 3 ? (69 / columnCount) : 100);
                                                                            return validLabels.map((clist: any, childidx: number) => (
                                                                                clist.label && <TableCell
                                                                                    key={childidx}
                                                                                    align="center"
                                                                                    sx={{
                                                                                        width: `${widthPercent}%`,
                                                                                        padding: 0
                                                                                    }}
                                                                                >
                                                                                    {clist.label}
                                                                                </TableCell>
                                                                            ));
                                                                        })()}
                                                                    </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                    <TableRow>
                                                                        {(() => {
                                                                            const validFields = list.childDetails.filter((clist: any) => clist.type !== "");
                                                                            const columnCount = validFields.length;
                                                                            const widthPercent = columnCount > 0 ? (100 / columnCount) : 100;
                                                                            return validFields.map((clist: any, childidx: number) => (
                                                                                <TableCell
                                                                                    key={childidx}
                                                                                    sx={{
                                                                                        padding: 0,
                                                                                        width: `${widthPercent}%`
                                                                                    }}
                                                                                >
                                                                                    {/* Text Input */}
                                                                                    {clist.type === 'text' && (
                                                                                        <CustomTextField
                                                                                            fullWidth
                                                                                            id={clist.shortName}
                                                                                            name={clist.shortName}
                                                                                            value={clist.value || ''}
                                                                                            onChange={(e) =>
                                                                                                handleFieldChange("b", i, clist.shortName, e.target.value)
                                                                                            }
                                                                                            inputProps={{
                                                                                                maxLength: 45
                                                                                            }}
                                                                                            readOnly={lockFields || roleFlag}
                                                                                            sx={{ pl: 2 }}
                                                                                        />
                                                                                    )}

                                                                                    {/* Number Input */}
                                                                                    {clist.type === 'number' && (
                                                                                        <CustomTextField
                                                                                            fullWidth
                                                                                            id={clist.shortName}
                                                                                            name={clist.shortName}
                                                                                            value={clist.value || ''}
                                                                                            onKeyDown={(e) => {
                                                                                                if (!/\d/.test(e.key)) e.preventDefault();
                                                                                            }}
                                                                                            onChange={(e) =>
                                                                                                handleFieldChange("b", i, clist.shortName, e.target.value)
                                                                                            }
                                                                                            readOnly={lockFields || roleFlag}
                                                                                            sx={{ pl: 2 }}
                                                                                        />
                                                                                    )}

                                                                                    {/* Currency Input */}
                                                                                    {clist.type === 'currency' && (

                                                                                        <NumericFormat
                                                                                            customInput={CustomTextField}
                                                                                            id={clist.shortName}
                                                                                            name={clist.shortName}
                                                                                            value={clist.value ?? ""}
                                                                                            thousandSeparator
                                                                                            placeholder="0.00"
                                                                                            decimalScale={2}
                                                                                            fixedDecimalScale={false}
                                                                                            allowNegative={true}
                                                                                            onValueChange={(values) => {
                                                                                                handleFieldChange("b", i, clist.shortName, unformatCurrencyInput(values.value));
                                                                                            }}
                                                                                            isAllowed={(values) => {
                                                                                                const { floatValue } = values;
                                                                                                return (
                                                                                                    floatValue === undefined ||
                                                                                                    floatValue <= constants.MAX_AMOUNT_ALLOWED
                                                                                                );
                                                                                            }}
                                                                                            inputProps={{
                                                                                                style: {
                                                                                                    textAlign: "right",
                                                                                                    paddingLeft: 0,
                                                                                                    marginRight: 0.1
                                                                                                },
                                                                                                onPaste: (e: any) => e.preventDefault()
                                                                                            }}
                                                                                            InputProps={{
                                                                                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                                                                style: { textAlign: 'right' }
                                                                                            }}
                                                                                            sx={{
                                                                                                width: list.childDetails.length < 3 ? '60%' : '100%',
                                                                                                marginLeft: 'auto',
                                                                                                pl: 2
                                                                                            }}
                                                                                            readOnly={lockFields || roleFlag}
                                                                                        />

                                                                                    )}

                                                                                    {/* Radio Group */}
                                                                                    {clist.type === 'radio' && (
                                                                                        <RadioGroup
                                                                                            row
                                                                                            value={clist.value || ''}
                                                                                            onChange={(e) =>
                                                                                                handleFieldChange("b", i, list.shortName, e.target.value)
                                                                                            }
                                                                                            sx={{ justifyContent: 'center', width: '100%', pl: 2 }}
                                                                                        >
                                                                                            <FormControlLabel
                                                                                                value="1"
                                                                                                control={<Radio />}
                                                                                                label="Yes"
                                                                                                disabled={lockFields || roleFlag}
                                                                                            />
                                                                                            <FormControlLabel
                                                                                                value="0"
                                                                                                control={<Radio />}
                                                                                                label="No"
                                                                                                disabled={lockFields || roleFlag}
                                                                                            />
                                                                                        </RadioGroup>
                                                                                    )}

                                                                                    {/* Date Picker */}
                                                                                    {clist.type === 'date' && (
                                                                                        <CustomDatePicker
                                                                                            type="date"
                                                                                            id={clist.shortName}
                                                                                            name={clist.shortName}
                                                                                            onChange={(value) =>
                                                                                                handleFieldChange("b", i, clist.shortName, value ? value.toISOString() : "")
                                                                                            }
                                                                                            value={list.value && list.value.date ? dayjs(`${list.value.date.year}-${list.value.date.month}-${list.value.date.day}`) : null}
                                                                                            readOnly={lockFields || roleFlag}
                                                                                            sx={{ pl: 2 }}
                                                                                        />
                                                                                    )}
                                                                                </TableCell>
                                                                            ));
                                                                        })()}
                                                                    </TableRow>

                                                                </TableBody>
                                                            </TableContainer>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Box>
                                ))}
                            </>
                        ) : (
                            <Box>
                                <SubSectionTitle>
                                    {translate('reportDetailsAreNotConfiguredPleaseContactTheAdministrator')}
                                </SubSectionTitle>
                            </Box>
                        )}

                        <Box className={basestyle.buttoncontainer}>
                            <ContainedButton onClick={handleBack}> {translate('back')} </ContainedButton>
                            {!(lockFields || roleFlag) && <ContainedButton onClick={handleSave}> {translate('save')} </ContainedButton>}
                            {!(lockFields || roleFlag) && <OutlinedButton onClick={handleCancel}> {translate('cancel')} </OutlinedButton>}
                            {!(lockFields || roleFlag) && <ContainedButton onClick={handlePrint}> {translate('print')} </ContainedButton>}
                        </Box>
                        <CancelPopUp
                            open={openPopUp}
                            popupTitle={translate('confirmCancel')}
                            handleClose={handlePopUpClose}
                            saveChanges={() => handleConfirm()}
                            message={translate('doYouWantToCancelChanges?')}
                        />
                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 1,
                                display: "flex",
                                flexDirection: "column",
                            }}
                            open={loadingFlag}
                        >
                            <CircularProgress color="inherit" />
                            <SubSectionTitle  >{translate('pleasewait')}</SubSectionTitle>
                        </Backdrop>
                    </Box>
                </StyledTwoChildContainer>
            </StyledOneChildContainer>
        </StyledParentContainer>
    );
};

export default ActualsReportView;

